<template>
  <div class="chart-container">
    <b-card class="ticket-category-status">
      <b-card-header>
        <b-card-title>Ticket Category Distribution</b-card-title>
      </b-card-header>
      <apexcharts
        ref="chart"
        height="350"
        type="pie"
        :options="chartOptions"
        :series="chartSeries"
      ></apexcharts>
    </b-card>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { BCard, BCardTitle, BCardHeader } from "bootstrap-vue";

export default {
  name: "TicketCategoryChart",
  components: {
    apexcharts: VueApexCharts,
    BCard,
    BCardHeader,
    BCardTitle,
  },
  props: {
    data: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  computed: {
    chartSeries() {
      return this.data.map(item => item.ticketCount);
    },
    
    chartOptions() {
      return {
        chart: {
          type: 'pie',
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
            }
          }
        },
        labels: this.data.map(item => item.ticketCategory),
        colors: [
          '#FF6384', // Pink
          '#36A2EB', // Blue
          '#FFCE56', // Yellow
          '#4BC0C0', // Teal
          '#9966FF', // Purple
          '#FF9F40', // Orange
          '#FF99CC', // Light Pink
          '#66FF99', // Light Green
        ],
        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
          fontSize: '14px',
          markers: {
            width: 12,
            height: 12,
            radius: 6,
          },
          itemMargin: {
            horizontal: 10,
            vertical: 5
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function(val, opts) {
            return opts.w.globals.series[opts.seriesIndex] + ' tickets\n(' + val.toFixed(1) + '%)';
          },
          style: {
            fontSize: '12px'
          }
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return val + ' tickets';
            }
          }
        },
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 300
            },
            legend: {
              position: 'bottom',
              offsetY: 10
            }
          }
        }],
        stroke: {
          width: 2,
          colors: ['#fff']
        },
        title: {
          text: 'Total Tickets by Category',
          align: 'center',
          style: {
            fontSize: '16px'
          }
        }
      };
    }
  }
};
</script>

<style scoped>
.chart-container {
  padding: 1rem;
}

.ticket-category-status {
  min-height: 450px;
}
</style>